import React from "react";

const infoCard = ({ icon, title, subtitle }) => {
  return (
    <div className="about__box">
      <i class={`${icon} about__icon`}></i>
      <h3 className="about__title">{title}</h3>
      <span className="about__subtitle"> {subtitle} </span>
    </div>
  );
};

export default infoCard;
